import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomer, BackendQueryCustomerArgs } from 'src/types/backend';

import { FRAGMENT_FEATURE_LIMIT } from './schema';

const QUERY = gql`
  query CustomerFeatureLimit($id: ID!) {
    customer(id: $id) {
      id
      featureLimits {
        ...FeatureLimit
      }
    }
  }
  ${FRAGMENT_FEATURE_LIMIT}
`;

type Variables = BackendQueryCustomerArgs;
type Result = Pick<BackendCustomer, 'id' | 'featureLimits'>;

export const queryCustomerFeatureLimit = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
